import react, { useState, useEffect } from 'react';
import PopUpLoader from './PopUpLoader';
import axios from 'axios'

const AssignToVisit = (props) => {

    const [usersData, setUsersData] = useState([]);
    const [userId, setUserId] = useState("");
    const [filter, setFilter] = useState("");
    const [loadingToggle, setLoadingToggle] = useState(0);
    const [alertToggle, setAlertToggle] = useState(0);
    const [alertMessage, setAlertMessage] = useState("Lead successfully added");
    const [alertColor, setAlertColor] = useState("crm-color-green");

    const url2 = window.url2;
    const qry = new FormData();

    useEffect(() => {
        fetchUsersApi();
        // console.log(props.data);
    }, []);

    const fetchUsersApi = () => {
        qry.append("emp_id", "");
        axios.post(url2 + "fetch-users.php", qry).then((response) => {
            if (response.data.status == 1) {
                setUsersData(response.data.data);
                // console.log(response.data);
            }
        }).catch(error => {
            console.log("error");
        });
    }

    const assignApi = (e) => {
        e.preventDefault();

        setLoadingToggle(1);

        const data = new FormData();
        data.append("emp_id", props.emp_id);
        data.append("data", props.data);
        data.append("user", userId);

        axios.post(url2 + "assign-to-visit.php", data).then((response) => {
            if (response.data.status == 1) {
                setLoadingToggle(0);
                setAlertMessage(response.data.msg);
                setAlertToggle(1);

                props.reload();

                setTimeout(() => {
                    props.close();
                }, 500);
            }
            // console.log(response.data);
        }).catch(error => {
            console.log("error");
        });
    }

    return (
        <>
            <div className="dark-background">
                <div className='add-new-lead-popup'>

                    {loadingToggle == 1 ?
                        <PopUpLoader />
                        : <></>
                    }

                    {alertToggle == 1 ?
                        <div className='crm-alert'>
                            <p className={alertColor}> {alertMessage} </p>
                        </div>
                        : <></>
                    }

                    <div className='add-new-head'>
                        <h2> Assign to Visit <i className='fa fa-forward'></i> </h2>
                        <i className='fa fa-times cross' onClick={props.close}></i>
                    </div>

                    <div className='form'>
                        <p className='crm-color-green' style={{ "margin": "10px 0" }}>{props.data.length} {props.data.length == 0 ? "Leads Selected" : "Leads Assigning"} </p>
                        
                        <form onSubmit={assignApi}>


                            {/* <label> For Site </label>

                            <select required>
                                <option value=""> select </option>
                                <option value=""> Anmol Vihar </option>
                                <option value=""> Supreme Field </option>
                            </select> */}

                            <label> Coordinator </label>

                            <select required onChange={(e) => setUserId(e.target.value)} disabled={props.data.length == 0 ? "disabled" : ""}>
                                <option value=""> select </option>
                                {usersData.length != 0 ?
                                    <>
                                        {
                                            usersData.filter(item => item.designation == "E" || item.designation == "F").map(data => {
                                                return (
                                                    <option value={data.id}> {data.name} ({data.designation == "E" ? "Visitor" : data.designation == "F" ? "Regional Manager" : ""})</option>
                                                )
                                            })
                                        }
                                    </> :
                                    <></>
                                }
                            </select>

                            <button type='submit' className='crm-btn-primary' disabled={props.data.length == 0 ? "disabled" : ""}> Assign <i className='fa fa-forward'></i> </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AssignToVisit;